<div class="not-found-container" data-testid="not-found-container">
  <div class="not-found-content">
    <h1 class="error-code" data-testid="not-found-code">404</h1>
    <h2 class="error-title" data-testid="not-found-title">Pagina niet gevonden</h2>
    <p class="error-message" data-testid="not-found-message">
      De pagina die u heeft opgevraagd bestaat niet of is niet meer beschikbaar.
    </p>
    <div class="action-buttons">
      <button mat-flat-button color="primary" (click)="goToDashboard()" data-testid="not-found-dashboard-button">
        Terug naar Dashboard
      </button>
    </div>
  </div>
</div>
